// Pure helpers for the Books tab (QuickBooks Online sync).

export const STATE_TEXT = { synced: 'Synced', ready: 'Ready', waiting: 'Waits for approval', failed: "Didn't post" };

export const toSync = (data) => (data?.stats?.ready || 0) + (data?.stats?.attention || 0);

/** The one primary action for the tab, or null. */
export function booksAction(data) {
  const c = data?.connection;
  if (!c) return null;
  if (c.status === 'needs_reconnect') return { kind: 'reconnect', label: `Reconnect ${c.name}` };
  if (!c.mapped) return { kind: 'map', label: 'Choose accounts' };
  const n = toSync(data);
  if (n > 0) return { kind: 'sync', label: `Sync ${n} record${n === 1 ? '' : 's'}` };
  return null;
}

export function booksStats(data) {
  const s = data?.stats || {};
  return [
    { label: 'Synced to your books', value: String(s.synced || 0) },
    { label: 'Ready to sync', value: String(s.ready || 0) },
    { label: 'Need attention', value: String(s.attention || 0), attention: (s.attention || 0) > 0 },
  ];
}

export function fmtWhen(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-CA', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'America/Toronto' });
}

export function connectionMeta(c) {
  if (!c) return [];
  return [c.org_name, c.environment === 'sandbox' ? 'Sandbox' : null,
    c.last_synced_at ? `Last synced ${fmtWhen(c.last_synced_at)}` : 'Not synced yet'].filter(Boolean);
}

export function rowMeta(r, money) {
  const docs = (r.docs || []).map((d) => (d.number ? `${d.label} ${d.number}` : d.label));
  return [r.agent, `${money(r.gross)} gross`, r.state === 'synced' ? docs.join(', ') : r.note].filter(Boolean);
}

export function mappingMissing(selected, roles) {
  return (roles || []).filter((r) => !(selected || {})[r.key]).map((r) => r.label);
}

export function bannerFor(param) {
  return { connected: 'Connected. Choose your accounts next.', failed: "That didn't connect. Try again.",
    cancelled: 'Connecting was cancelled.', off: "Syncing to your books isn't switched on yet." }[param] || null;
}
